import React, { useEffect, useState } from "react";
import Completed from "@assets/images/icons/user-tick.svg";
import { Button } from "@components/library";
import { registrationVerify } from "@actions/auth/registrationVerify";
import { Footer } from "@components/layout/Footer";
import { HeaderUnauth } from "@components/layout/Header/HeaderUnauth";
import { Box, Skeleton } from "@mui/material";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

export const SignUpHash = () => {
  const dispatch = useDispatch();
  const { hash } = useParams();
  // const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    dispatch(registrationVerify({ hash }))
      .then(() => {
        // navigate("/");
      })
      .catch((error) => {
        console.log(error.response.data);
      })
      .finally(() => {
        setLoading(false);
      });

    // return () => {
    //   dispatch({ type: AUTH.AUTH_IS_AUTH, payload: true });
    // };
  }, []);

  return (
    <div className={`base-wrap`}>
      <div className="base-wrap__header">
        <HeaderUnauth />
      </div>

      <div className="base-wrap__content">
        <main className="auth auth">
          <div className="auth__wrapper">
            <div className="completed">
              {loading ? (
                <>
                  <Skeleton
                    variant="rounded"
                    width={80}
                    height={80}
                    sx={{ margin: "0 auto", bgcolor: "#292929" }}
                  />
                  <Box sx={{ marginY: "10px" }}>
                    <Skeleton
                      variant="text"
                      sx={{ fontSize: "51px", bgcolor: "#292929" }}
                    />
                  </Box>
                  <Box sx={{ marginBottom: "24px" }}>
                    <Skeleton
                      variant="text"
                      sx={{ fontSize: "25px", bgcolor: "#292929" }}
                    />
                  </Box>

                  <Skeleton
                    variant="rounded"
                    width={195}
                    height={56}
                    sx={{
                      margin: "0 auto",
                      fontSize: "51px",
                      bgcolor: "#292929",
                    }}
                  />
                </>
              ) : (
                <>
                  <picture className="completed__icon">
                    <img src={Completed} alt="user tick" />
                  </picture>

                  <h1 className="completed__title">Registration completed</h1>

                  <p className="completed__text">
                    You have successfully created an account.
                  </p>

                  <Button
                    className="completed__btn"
                    to="/"
                    size="middle"
                    type="link"
                    color="orange"
                  >
                    Go to Dashboard
                  </Button>
                </>
              )}
            </div>
          </div>
        </main>
      </div>

      <div className="base-wrap__footer">{<Footer />}</div>
    </div>
  );
};

export default SignUpHash;
